import type { TraceMessage } from '../types';

export function messageContainsOperationId({
  message,
  operationId,
}: {
  message: TraceMessage;
  operationId: string;
}): boolean {
  return message.content.some((content) => {
    if (content.type !== 'tool_call') {
      return false;
    }

    const metadataOperationId = content.toolCall.metadata?.operationId;
    return (
      typeof metadataOperationId === 'string' &&
      metadataOperationId === operationId
    );
  });
}
